/**
 * Slugify a human label into a URL-safe identifier.
 *   "CoreFi 2026" → "corefi-2026"
 *   "  Hello, world! " → "hello-world"
 * The Go API has its own validator (a-z0-9-_, 2-64 chars); we just keep the
 * UI hint reasonable. Trailing dashes are stripped so the API doesn't reject.
 */
export function slugify(value: string): string {
  return value
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 64);
}
